"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RefreshCw, X } from 'lucide-react';
interface UpdateNotificationProps {
  isVisible: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}
export default function UpdateNotification(t0) {
  const $ = _c(6);
  const {
    isVisible,
    onUpdate,
    onDismiss
  } = t0;
  let t1;
  if ($[0] !== isVisible || $[1] !== onDismiss || $[2] !== onUpdate) {
    t1 = isVisible && <motion.div initial={{
      opacity: 0,
      y: -100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -100
    }} transition={{
      duration: 0.3,
      ease: "easeOut"
    }} className="fixed top-4 left-1/2 -translate-x-1/2 z-50 max-w-md w-full mx-4"><div className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden"><div className="bg-gradient-to-r from-[#6059f7] to-[#9d96ff] p-4"><div className="flex items-center justify-between"><div className="flex items-center gap-3"><div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center"><RefreshCw className="w-5 h-5 text-white" /></div><div><h3 className="text-white font-semibold text-lg">New Version Available</h3><p className="text-white/90 text-sm">Update ready to install</p></div></div><button onClick={onDismiss} className="text-white/80 hover:text-white transition-colors" aria-label="Dismiss"><X className="w-5 h-5" /></button></div></div><div className="p-4 bg-white"><p className="text-gray-600 text-sm mb-4">A new version of the application is available. Update now to get the latest features and improvements.</p><div className="flex gap-3"><button onClick={onUpdate} className="flex-1 py-2.5 bg-[#6059f7] text-white rounded-lg font-semibold hover:bg-[#5048e8] transition-all shadow-lg shadow-[#6059f7]/20 flex items-center justify-center gap-2"><RefreshCw className="w-4 h-4" />Update Now</button><button onClick={onDismiss} className="px-4 py-2.5 text-gray-600 hover:text-gray-900 transition-colors font-medium">Later</button></div></div></div></motion.div>;
    $[0] = isVisible;
    $[1] = onDismiss;
    $[2] = onUpdate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}